// extracted by mini-css-extract-plugin
export default {"autoTagging":"wSmcOZUc3swL7HohRrda"};